// @ts-check
import { gql } from '@apollo/client';
import { Trans } from '@lingui/macro';
import { useHistory } from 'react-router-dom';
import { SkeletonText, TabbedMenu, TabbedMenuItem } from '~/design-system';
import { useCommonLinks } from '../../pages/imports/_config';

const states = {
  inProgress: 'inProgress',
  completed: 'completed',
  failed: 'failed',
};

export default function ImportTabbedMenu({
  loading,
  tab,
  inProgressCount,
  completedCount,
  failedCount,
}) {
  const history = useHistory();
  const link = useCommonLinks();
  if (loading) return <ImportTabbedMenuSkeleton />;
  return (
    <TabbedMenu sx={{ margin: 0 }}>
      <TabbedMenuItem
        isActive={tab === states.inProgress}
        onClick={() => history.push(link.importsInProgress())}
      >
        <Trans>In progress ({inProgressCount})</Trans>
      </TabbedMenuItem>
      {completedCount > 0 && (
        <TabbedMenuItem
          isActive={tab === states.completed}
          onClick={() => history.push(link.importsCompleted())}
        >
          <Trans>Completed ({completedCount})</Trans>
        </TabbedMenuItem>
      )}
      {failedCount > 0 && (
        <TabbedMenuItem
          isActive={tab === states.failed}
          onClick={() => history.push(link.importsFailed())}
        >
          <Trans>Failed ({failedCount})</Trans>
        </TabbedMenuItem>
      )}
    </TabbedMenu>
  );
}

function ImportTabbedMenuSkeleton() {
  return (
    <TabbedMenu sx={{ margin: 0 }}>
      <TabbedMenuItem>
        <SkeletonText width={100} />
      </TabbedMenuItem>
      <TabbedMenuItem>
        <SkeletonText width={100} />
      </TabbedMenuItem>
      <TabbedMenuItem>
        <SkeletonText width={100} />
      </TabbedMenuItem>
    </TabbedMenu>
  );
}

ImportTabbedMenu.fragment = gql`
  fragment ImportTabbedMenu on Workspace {
    inProgress: dataImports(
      filter: { state: { in: ["JOB_IN_PROGRESS", "STARTED"] } }
    ) {
      totalCount
    }
    failed: dataImports(filter: { state: { eq: "ERROR" } }) {
      totalCount
    }
    completed: dataImports(filter: { state: { eq: "COMPLETED" } }) {
      totalCount
    }
  }
`;
